<template>
  <v-dialog persistent v-model="dialog" max-width="400">
    <v-card class="pa-2">
      <v-card-title class="headline">{{
        $vuetify.lang.t("$vuetify.TWO_FA")
      }}</v-card-title>
      <v-card-text>
        <p>{{ $vuetify.lang.t("$vuetify.INSERT_CODE") }}</p>
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.CODE')"
          v-model="code"
          maxlength="6"
          outlined
          type="text"
          autofocus
          dense
          class="mt-8"
          @keypress.enter="verifyCode"
        ></v-text-field>
        <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
        <v-alert v-if="success" type="success" dense>{{
          $vuetify.lang.t("$vuetify.VERIFICADO_SUCESSO")
        }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center" class="w-100">
          <v-btn color="primary" @click="verifyCode" :loading="loading">
            {{ $vuetify.lang.t("$vuetify.VERIFICAR") }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    close: Function,
  },
  data() {
    return {
      code: "",
      loading: false,
      error: null,
      success: false,
    };
  },
  methods: {
    verifyCode() {

      this.loading = true;
      this.error = null;
      this.success = false;

      this.$post("/2fa/verify", { code: this.code }).then((response) => {
        
        if (response.data.code == 500) {
          this.loading = false;
          this.error = this.$vuetify.lang.t("$vuetify.CODIGO_INVALIDO");
        } else {
          this.success = true;

        this.$get("/usuario").then((user) => {
          window.sessionStorage.setItem('user', JSON.stringify(user.data));

          setTimeout(() => {
            this.loading = false;
            this.close();
            this.$root.$emit("login-success");
          }, 1000);
         });
        }
      });
    },
  },
};
</script>
